export default __webpack_public_path__ + "static/media/fi_above_16.40493fa7.png";